export default __webpack_public_path__ + "static/media/IconMagnifyingGlassInactive.80b531ab.svg";